'use client'

import { useEffect } from 'react'
import type { IProductDetail } from '@/schemas/catalog/product'
import { useProductStore } from '@/stores/useProductStore'

/**
 * Produto aberto na PDP. A página busca o produto no servidor (`getProductPageService`) e a tela renderiza das props;
 * este hook só grava o produto na `useProductStore`, de onde frete e quantidade leem, e limpa ao sair da PDP. Não usa o
 * React Query: o produto já chega pronto nas props do server component, e uma consulta no navegador repetiria a busca
 * que o servidor fez (ou, com `initialData`, guardaria no cache uma cópia que a página não lê).
 */
export function useCurrentProduct({ product, productSizes }: IProductDetail) {
    const setCurrentProduct = useProductStore((state) => state.setCurrentProduct)
    const clearCurrentProduct = useProductStore((state) => state.clearCurrentProduct)

    useEffect(() => {
        setCurrentProduct(product, productSizes)
    }, [product, productSizes, setCurrentProduct])

    useEffect(() => clearCurrentProduct, [clearCurrentProduct])
}
